import { useEffect, useRef } from 'react';

type GoogleReviewsWidgetProps = {
  embedCode: string;
};

/** Injecte le code embed Elfsight / SociableKIT / Taggbox / EmbedSocial. */
export function GoogleReviewsWidget({ embedCode }: GoogleReviewsWidgetProps) {
  const hostRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const host = hostRef.current;
    if (!host || !embedCode.trim()) return;

    host.innerHTML = '';
    const mount = document.createElement('div');
    mount.className = 'google-reviews-widget w-full';
    mount.innerHTML = embedCode.trim();
    host.appendChild(mount);

    mount.querySelectorAll('script').forEach((oldScript) => {
      const script = document.createElement('script');
      Array.from(oldScript.attributes).forEach((attr) => {
        script.setAttribute(attr.name, attr.value);
      });
      script.textContent = oldScript.textContent;
      oldScript.parentNode?.replaceChild(script, oldScript);
    });

    return () => {
      host.innerHTML = '';
    };
  }, [embedCode]);

  return (
    <div
      ref={hostRef}
      className="w-full min-h-[320px] rounded-[2rem] border border-gray-100 bg-gray-50/50 p-4 sm:p-6 overflow-hidden"
    />
  );
}
